import Layout from '@/layout/layout'

const basicData = {
  path: '/autoQuoteManage',
  component: Layout,
  redirect: 'noRedirect',
  name: '自动报价管理',
  children: [
    {
      path: 'quoteModelConfig',
      component: () => import('@/views/autoQuoteManage/quoteModelConfig/index'),
      name: '报价机型配置',
      meta: { title: '报价机型配置', noCache: true }
    },
    {
      path: 'basicQuoteConfig',
      component: () => import('@/views/autoQuoteManage/basicQuoteConfig/index'),
      name: '基础报价配置',
      meta: { title: '基础报价配置', noCache: true }
    },
    {
      path: 'faultdeDuctionConfig',
      component: () => import('@/views/autoQuoteManage/faultdeDuctionConfig/index'),
      name: '故障项扣费配置',
      meta: { title: '故障项扣费配置', noCache: true }
    }
  ]
}

export default basicData